
import React from "react";
import { Link, useLocation } from "react-router-dom";

const serviceAreas = [
  {
    label: "Törekent Halı Yıkama",
    path: "/sincan/torekent-hali-yikama",
    description:
      "Törekent bölgesine özel halı yıkama servisimizde, modern makineler ve hijyenik yıkama teknikleri ile derinlemesine temizlik sağlıyoruz. Ücretsiz servisimizle halılarınızı evinizden alıyor, tam otomatik makinelerde yıkayıp, zamanında teslim ediyoruz."
  },
  {
    label: "Fatih Halı Yıkama",
    path: "/sincan/fatih-hali-yikama",
    description:
      "Fatih Mahallesi sakinlerine sunduğumuz profesyonel halı yıkama hizmetimizde, lekeleri yok eden özel şampuanlar ve bakterileri arındıran yüksek ısılı durulama sistemleri kullanılmaktadır. Müşteri memnuniyeti odaklı, hızlı ve güvenilir hizmet sunuyoruz."
  },
  {
    label: "Yenikent Halı Yıkama",
    path: "/sincan/yenikent-hali-yikama",
    description:
      "Yenikent’te halılarınızı ilk günkü canlılığına kavuşturuyoruz. Antialerjik deterjanlarla yapılan yıkama sürecimiz, özellikle çocuklu ve evcil hayvanlı evler için idealdir. Halılarınız itina ile paketlenerek ücretsiz teslim edilmektedir."
  },
  {
    label: "Sincan Halı Yıkama Yorumlar",
    path: "/sincan/yorumlar",
    description:
      "Sincan’ın tüm mahallelerine yaygın servis ağımızla ulaşmaktayız. Halı, koltuk, yorgan ve battaniye yıkama hizmetlerini titizlikle yerine getiriyor, her müşterimize özel çözümler sunuyoruz. 7 gün hizmet, hızlı dönüş ve ekonomik fiyat garantisi!"
  }
];


const SincanSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
        <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">SİNCAN SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {serviceAreas.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SincanSidebar;
